import { Fragment as _Fragment } from "react/jsx-runtime";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
} //import "@dp/xcomp/src/index.css"


import { StoreProvider } from "@dp/state";
import { DataLayer, WebUtils } from "@dp/web";
import App from "next/app";
import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import LayoutSwitcher from "../layouts/LayoutSwitcher";
import RootS from "../store";
import "../theme/main.style.scss";
import { bootstrapClientSidePage } from "../util/util";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import ResizeObserver from "resize-observer-polyfill";
import smoothscroll from "smoothscroll-polyfill";
import { ErrorBoundary } from "react-error-boundary";
import TagManager from "react-gtm-module";
import "react-spring-bottom-sheet/dist/style.css"; // const LoginPopup = React.lazy(() =>
//   import("@dp/web").then((module) => ({
//     default: module.LoginPopup,
//   })),
// );
// const LoginPopup = React.lazy(() =>
//   import("@dp/xcomp/src/components/common").then((module) => ({
//     default: module.LoginPopup,
//   })),
// );

/*const SocialLoginPopup = React.lazy(() =>
  import("@dp/web").then((module) => ({
    default: module.SocialLoginPopup,
  })),
);*/

var ErrorFallback = function ErrorFallback() {
  return /*#__PURE__*/_jsx("div", {
    className: "container",
    children: /*#__PURE__*/_jsx("div", {
      className: "row",
      children: /*#__PURE__*/_jsx("div", {
        className: "col",
        children: /*#__PURE__*/_jsxs("div", {
          role: "alert",
          className: "alert alert-danger text-center align-middle mt-5",
          children: ["We are sorry, but something went wrong. Let's take you", " ", /*#__PURE__*/_jsx("a", {
            href: "/",
            className: "trackContent",
            "data-link-info": "error page | link to home",
            children: /*#__PURE__*/_jsx("u", {
              children: "home"
            })
          }), "."]
        })
      })
    })
  });
};

var myErrorHandler = function myErrorHandler(error, info) {
  var _RootS$platformUtil, _RootS$platformUtil$p, _RootS$platformUtil2;

  var platformDescription = (RootS === null || RootS === void 0 ? void 0 : (_RootS$platformUtil = RootS.platformUtil) === null || _RootS$platformUtil === void 0 ? void 0 : (_RootS$platformUtil$p = _RootS$platformUtil.platformDetails()) === null || _RootS$platformUtil$p === void 0 ? void 0 : _RootS$platformUtil$p.description) || "";
  RootS === null || RootS === void 0 ? void 0 : (_RootS$platformUtil2 = RootS.platformUtil) === null || _RootS$platformUtil2 === void 0 ? void 0 : _RootS$platformUtil2.dispatchEvent("AnalyticsEvent", "CoreCodeError", {
    faultCode: error.name + ": " + error.message + info.componentStack + platformDescription
  });
};

var loadTheme = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(brand) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.log("brand == " + brand);
            _context.t0 = brand;
            _context.next = _context.t0 === "OG" ? 4 : _context.t0 === "OGC" ? 6 : _context.t0 === "LH" ? 8 : _context.t0 === "CS" ? 10 : _context.t0 === "BB" ? 12 : _context.t0 === "YH" ? 14 : _context.t0 === "S52" ? 16 : _context.t0 === "EV" ? 18 : _context.t0 === "CG" ? 20 : _context.t0 === "CB" ? 22 : _context.t0 === "RC" ? 24 : 26;
            break;

          case 4:
            import("../theme/og.style.scss");
            return _context.abrupt("break", 27);

          case 6:
            import("../theme/og.style.scss");
            return _context.abrupt("break", 27);

          case 8:
            import("../theme/lh.style.scss");
            return _context.abrupt("break", 27);

          case 10:
            import("../theme/cs.style.scss");
            return _context.abrupt("break", 27);

          case 12:
            import("../theme/bb.style.scss");
            return _context.abrupt("break", 27);

          case 14:
            import("../theme/yh.style.scss");
            return _context.abrupt("break", 27);

          case 16:
            import("../theme/52.style.scss");
            return _context.abrupt("break", 27);

          case 18:
            import("../theme/ev.style.scss");
            return _context.abrupt("break", 27);

          case 20:
            import("../theme/cg.style.scss");
            return _context.abrupt("break", 27);

          case 22:
            import("../theme/cb.style.scss");
            return _context.abrupt("break", 27);

          case 24:
            import("../theme/rc.style.scss");
            return _context.abrupt("break", 27);

          case 26:
            import("../theme/og.style.scss");

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loadTheme(_x) {
    return _ref.apply(this, arguments);
  };
}();

var loadFonts = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(brand) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            console.log("brand == " + brand);
            _context2.t0 = brand;
            _context2.next = _context2.t0 === "OG" ? 4 : _context2.t0 === "OGC" ? 6 : _context2.t0 === "LH" ? 8 : _context2.t0 === "CS" ? 10 : _context2.t0 === "BB" ? 12 : _context2.t0 === "YH" ? 14 : _context2.t0 === "S52" ? 16 : _context2.t0 === "EV" ? 18 : _context2.t0 === "CG" ? 20 : _context2.t0 === "CB" ? 22 : _context2.t0 === "RC" ? 24 : 26;
            break;

          case 4:
            import("../theme/og.fonts.css");
            return _context2.abrupt("break", 27);

          case 6:
            import("../theme/og.fonts.css");
            return _context2.abrupt("break", 27);

          case 8:
            import("../theme/lh.fonts.css");
            return _context2.abrupt("break", 27);

          case 10:
            import("../theme/cs.fonts.css");
            return _context2.abrupt("break", 27);

          case 12:
            import("../theme/bb.fonts.css");
            return _context2.abrupt("break", 27);

          case 14:
            import("../theme/yh.fonts.css");
            return _context2.abrupt("break", 27);

          case 16:
            import("../theme/52.fonts.css");
            return _context2.abrupt("break", 27);

          case 18:
            import("../theme/ev.fonts.css");
            return _context2.abrupt("break", 27);

          case 20:
            import("../theme/cg.fonts.css");
            return _context2.abrupt("break", 27);

          case 22:
            import("../theme/cb.fonts.css");
            return _context2.abrupt("break", 27);

          case 24:
            import("../theme/rc.fonts.css");
            return _context2.abrupt("break", 27);

          case 26:
            import("../theme/og.fonts.css");

          case 27:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function loadFonts(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var loadAudioEye = function loadAudioEye(audioEyeUrl) {
  WebUtils.loadScript(audioEyeUrl);
};

var loadCookieConsent = function loadCookieConsent(cookieConsentUrl, key, onLoad, urlAttributes) {
  WebUtils.loadScript(cookieConsentUrl, key, onLoad, urlAttributes, true);
};

var MyApp = /*#__PURE__*/function (_App) {
  _inherits(MyApp, _App);

  var _super = _createSuper(MyApp);

  function MyApp(props) {
    var _this;

    _classCallCheck(this, MyApp);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      ready: false,
      appBrand: null
    });

    _defineProperty(_assertThisInitialized(_this), "bootStrapClient", function (brand) {
      var Component = _this.props.Component;
      bootstrapClientSidePage(RootS).then(function (appBrand) {
        if (brand === null || brand === undefined || appBrand !== brand) {
          var _RootS$common, _appAttributes$config, _appAttributes$config2, _appAttributes$config3, _appAttributes$config4;

          var layout = Component["layout"] || "default";
          var appAttributes = RootS === null || RootS === void 0 ? void 0 : (_RootS$common = RootS.common) === null || _RootS$common === void 0 ? void 0 : _RootS$common.appAttributes;
          var cookieConsentUrl = appAttributes === null || appAttributes === void 0 ? void 0 : (_appAttributes$config = appAttributes.configs) === null || _appAttributes$config === void 0 ? void 0 : _appAttributes$config.cookieConsentUrl;
          var cookieConsentScriptUrl = appAttributes === null || appAttributes === void 0 ? void 0 : (_appAttributes$config2 = appAttributes.configs) === null || _appAttributes$config2 === void 0 ? void 0 : _appAttributes$config2.cookieConsentScriptUrl;
          var googleTagManagerID = appAttributes === null || appAttributes === void 0 ? void 0 : (_appAttributes$config3 = appAttributes.configs) === null || _appAttributes$config3 === void 0 ? void 0 : _appAttributes$config3.googleTagManagerID;
          var dataLayerName = appAttributes === null || appAttributes === void 0 ? void 0 : (_appAttributes$config4 = appAttributes.configs) === null || _appAttributes$config4 === void 0 ? void 0 : _appAttributes$config4.dataLayerName;

          if (cookieConsentScriptUrl) {
            var _appAttributes$config5, _appAttributes$config6;

            var urScriptlParams = appAttributes === null || appAttributes === void 0 ? void 0 : (_appAttributes$config5 = appAttributes.configs) === null || _appAttributes$config5 === void 0 ? void 0 : (_appAttributes$config6 = _appAttributes$config5.cookieConsentUrlScriptParams) === null || _appAttributes$config6 === void 0 ? void 0 : _appAttributes$config6.split(",");
            loadCookieConsent(cookieConsentScriptUrl, "", null, urScriptlParams);
          }

          if (cookieConsentUrl) {
            var _appAttributes$config7, _appAttributes$config8;

            var urlParams = appAttributes === null || appAttributes === void 0 ? void 0 : (_appAttributes$config7 = appAttributes.configs) === null || _appAttributes$config7 === void 0 ? void 0 : (_appAttributes$config8 = _appAttributes$config7.cookieConsentUrlParams) === null || _appAttributes$config8 === void 0 ? void 0 : _appAttributes$config8.split(",");
            loadCookieConsent(cookieConsentUrl, "", null, urlParams);
          }

          if (layout === "nbLayout") {
            var _RootS$common2, _RootS$common2$appAtt;

            loadFonts(appBrand === null || appBrand === void 0 ? void 0 : appBrand.toUpperCase());
            loadAudioEye(RootS === null || RootS === void 0 ? void 0 : (_RootS$common2 = RootS.common) === null || _RootS$common2 === void 0 ? void 0 : (_RootS$common2$appAtt = _RootS$common2.appAttributes) === null || _RootS$common2$appAtt === void 0 ? void 0 : _RootS$common2$appAtt.audioEyeURL);
          } else {
            loadTheme(appBrand === null || appBrand === void 0 ? void 0 : appBrand.toUpperCase());
            library.add(faTimes, faCheck);
          }

          if (googleTagManagerID) {
            TagManager.initialize({
              gtmId: googleTagManagerID,
              dataLayerName: dataLayerName
            });
          }
        }

        _this.setState({
          ready: true,
          appBrand: appBrand
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$props, Component, pageProps, router, brand, layout;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!window.ResizeObserver) {
                window.ResizeObserver = ResizeObserver;
              }

              if (!(typeof window.IntersectionObserver === "undefined")) {
                _context3.next = 4;
                break;
              }

              _context3.next = 4;
              return import("intersection-observer");

            case 4:
              smoothscroll.polyfill(); //Get brand from query param

              _this$props = _this.props, Component = _this$props.Component, pageProps = _this$props.pageProps, router = _this$props.router;
              console.log("_app.tsx componentDidMount" + router);
              brand = pageProps.brand;
              layout = Component["layout"] || "default";

              if (brand) {
                if (layout === "nbLayout") {
                  loadFonts(brand === null || brand === void 0 ? void 0 : brand.toUpperCase());
                } else {
                  loadTheme(brand === null || brand === void 0 ? void 0 : brand.toUpperCase());
                  library.add(faTimes, faCheck);
                }
              }

              if (layout !== "SEO") {
                _this.bootStrapClient(brand);

                _this.loadMobxConfiguration();
              }

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _this.state = {
      ready: false,
      appBrand: null
    };
    return _this;
  }

  _createClass(MyApp, [{
    key: "loadMobxConfiguration",
    value: function loadMobxConfiguration() {
      try {
        if (process.env.NEXT_PUBLIC_REACT_APP_DP_SERVICES_ENV !== "production") {
          RootS === null || RootS === void 0 ? void 0 : RootS.loadMobXconfig({
            enforceActions: "always",
            computedRequiresReaction: true,
            reactionRequiresObservable: true,
            observableRequiresReaction: true,
            disableErrorBoundaries: true
          });
        }
      } catch (e) {
        console.log(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          Component = _this$props2.Component,
          pageProps = _this$props2.pageProps;
      var _this$state = this.state,
          ready = _this$state.ready,
          appBrand = _this$state.appBrand;
      var renderingOnClient = true;
      var layout = Component["layout"] || "default";
      var layoutProps = Component["layoutProps"];

      if (layout === "SEO") {
        return /*#__PURE__*/_jsx(ErrorBoundary, {
          FallbackComponent: ErrorFallback,
          onError: myErrorHandler,
          children: /*#__PURE__*/_jsx(StoreProvider, {
            store: RootS,
            children: /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps))
          })
        });
      }

      if (renderingOnClient) {
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        pageProps["urlParams"] = urlParams;
        return !ready ? /*#__PURE__*/_jsx("div", {}) : /*#__PURE__*/_jsx(ErrorBoundary, {
          FallbackComponent: ErrorFallback,
          onError: myErrorHandler,
          children: /*#__PURE__*/_jsx(React.Suspense, {
            fallback: /*#__PURE__*/_jsx(_Fragment, {}),
            children: /*#__PURE__*/_jsx(StoreProvider, {
              store: RootS,
              children: /*#__PURE__*/_jsxs(LayoutSwitcher, _objectSpread(_objectSpread({}, pageProps), {}, {
                brand: appBrand,
                layout: layout,
                layoutProps: layoutProps,
                children: [/*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, pageProps), {}, {
                  brand: appBrand
                })), /*#__PURE__*/_jsx(DataLayer, {
                  analyticsData: layoutProps === null || layoutProps === void 0 ? void 0 : layoutProps.analyticsData
                })]
              }))
            })
          })
        });
      } else {
        return /*#__PURE__*/_jsx(ErrorBoundary, {
          FallbackComponent: ErrorFallback,
          onError: myErrorHandler,
          children: /*#__PURE__*/_jsx(StoreProvider, {
            store: RootS,
            children: /*#__PURE__*/_jsx(Component, _objectSpread({}, pageProps))
          })
        });
      }
    }
  }]);

  return MyApp;
}(App);

export default MyApp;